const MAX_WIDTH = 1200
const MAX_HEIGHT = 1200
const QUALITY = 0.8
const MAX_SIZE_BYTES = 800 * 1024

export async function compressImage(file: File): Promise<Blob> {
  if (!file.type.startsWith('image/')) {
    return file
  }

  return new Promise((resolve, reject) => {
    const img = new Image()
    const url = URL.createObjectURL(file)

    img.onload = () => {
      URL.revokeObjectURL(url)
      const canvas = document.createElement('canvas')
      let { width, height } = img

      if (width > MAX_WIDTH || height > MAX_HEIGHT) {
        const ratio = Math.min(MAX_WIDTH / width, MAX_HEIGHT / height)
        width = Math.round(width * ratio)
        height = Math.round(height * ratio)
      }

      canvas.width = width
      canvas.height = height
      const ctx = canvas.getContext('2d')
      if (!ctx) {
        resolve(file)
        return
      }

      ctx.drawImage(img, 0, 0, width, height)

      canvas.toBlob(
        (blob) => {
          if (!blob) {
            resolve(file)
            return
          }
          if (blob.size > MAX_SIZE_BYTES) {
            canvas.toBlob(
              (smallerBlob) => {
                resolve(smallerBlob || blob)
              },
              'image/jpeg',
              Math.max(0.1, QUALITY - 0.2)
            )
          } else {
            resolve(blob)
          }
        },
        'image/jpeg',
        QUALITY
      )
    }

    img.onerror = () => {
      URL.revokeObjectURL(url)
      reject(new Error('Error al cargar la imagen'))
    }

    img.src = url
  })
}
